class VideobilllandingController {
  constructor($state,$window,storage,laboxSSapi) {
    this.name = 'Video Bill Landing';
    this.state = $state;
    this.landingPageVideoBillLoader = true;

    if (storage.getItem('session','home_id') == "36063655") {
    console.log('specific case where it should polay the default video and get no api response');
    this.landingPageVideoBillError = true;
    this.landingPageVideoBillLoader = false;
    } else if (storage.getItem('session','home_id') == "36071973") {
    console.log('specific case where it should polay the default video and get no api response');
    this.landingPageVideoBillError = true;
    this.landingPageVideoBillLoader = false;
    } else {
      laboxSSapi.getVideoBill().then((res)=>{
        if(res && res.data._links){
          this.working_link = res.data._links['video-stream'][0].href;
          console.log('res.data["_links"]["video-stream"].href is ' + res.data._links['video-stream'][0].href);
          console.log('working link is ' + this.working_link);
          if (this.working_link != null && storage.getItem('session','home_id') != "40520101") {
          	console.log('res.data is ' + res.data);
            this.landingPageVideoBillLoader = false;
            this.landingPageVideoBillError = false;
          } else {
            console.log('res.data is ' + res.data);
            console.log('response works but has no link');
            this.landingPageVideoBillError = false;
            this.landingPageVideoBillLoader = false;
          }
        } else {
          console.log('res.data is ' + res.data);
        	console.log('no response from videobill');
          this.landingPageVideoBillError = true;
          this.landingPageVideoBillLoader = false;
        }
      });
    }
  }
}

VideobilllandingController.$inject = ['$state','$window','storage','laboxSSapi'];

export default VideobilllandingController;



// WEBPACK FOOTER //
// ./client/app/components/landingpage/videobilllanding/videobilllanding.controller.js